module.exports = __webpack_public_path__ + "img/img_display_5.7b854b10.svg";